"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _text = _interopRequireDefault(require("@ux/text"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _button = _interopRequireDefault(require("@ux/button"));
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _configContext = require("../../context/config-context");
var _tracking = require("@site/pattern-library-utils/tracking");
var _appConfig = require("../../config/app-config");
/**
 * Local Imports
 */

const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pc-c1rocrpu"
});
const BackButtonContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "BackButtonContainer",
  class: "pc-b1urmhs4"
});
const TagWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TagWrapper",
  class: "pc-tddkyot"
});

/**
 * PageEyebrow Component.
 *
 * @param {Object} props React props
 * @param {String} props.icon Icon Type
 * @param {String} props.ariaLabel Back button aria label
 * @param {String} props.partialTheme Partial Theme
 * @returns {React.ReactElement} PageEyebrow Component
 * @public
 */

function PageEyebrow({
  icon = 'checkmark',
  ariaLabel = 'back to previous page',
  partialTheme = 'navigate-low-contrast, precheck'
}) {
  const {
    configData,
    appParams
  } = (0, _configContext.useConfig)();
  const trackingData = (0, _tracking.create)('back-button', true, false);
  if (!configData.pageEyebrow) {
    return null;
  }
  const {
    pageTitle,
    pageTagLabel
  } = configData.pageEyebrow;

  // Hide back button when src equals SERP or hideBackButton is true
  const hideBackButton = appParams?.get('src') === _appConfig.SOURCE_TYPES.SERP || configData.commonContent?.hideBackButton;
  const handleBack = () => {
    if (typeof window !== 'undefined') {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = '/';
      }
    }
  };
  return /*#__PURE__*/_react.default.createElement(Container, null, !hideBackButton && /*#__PURE__*/_react.default.createElement(BackButtonContainer, {
    "data-partial": partialTheme
  }, /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
    "data-cy": "back-button",
    type: "button",
    icon: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "arrow-left"
    }),
    "aria-label": ariaLabel,
    onClick: handleBack
  }, trackingData))), pageTagLabel && /*#__PURE__*/_react.default.createElement(TagWrapper, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: icon
  })), /*#__PURE__*/_react.default.createElement(_tag.default, {
    dataCy: "page-tag-label",
    text: pageTagLabel,
    design: "highlight"
  })), pageTitle && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    "data-cy": "page-title",
    as: "title",
    text: pageTitle,
    size: 0
  }));
}
var _default = exports.default = PageEyebrow;
PageEyebrow.propTypes = {
  icon: _propTypes.default.string,
  ariaLabel: _propTypes.default.string,
  partialTheme: _propTypes.default.string
};